import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useNavigate, Link } from "react-router-dom";
import trasportApi from "../../api/trasportApi";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { BsChevronRight } from "react-icons/bs";
import PubSub from "pubsub-js";

const ContactView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [client, setClientclient] = useState(
    location.state ? location.state.id : {}
  );
  const [modalShow, setModalShow] = useState(false);

  //Commented Due to some fields on 24-Dec-2024
  useEffect(() => {
    fetchclient();
  }, []);

  const fetchclient = async () => {
    // if (!client.id && location.hasOwnProperty("pathname")) {
    //   client.id = location.pathname.split("/")[2];
    //   //console.log("pathnam===" + contact.id);
    // }
    let challanRecords = await trasportApi.fetchClientInvoicePaymentById(location.state ? location.state.id : client.id);

    if (challanRecords) {
      console.log("challanRec", challanRecords);
      setClientclient(challanRecords);
    }
  };

  const isdelete = async () => {
    let result = await trasportApi.deleteChallan(client.id);
    if (result.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Saved",
        message: "Record deleted successfully",
      });
      navigate(`/challans`);
    }
  };

  const editclient = () => {
    navigate(`/clientinvoicepayments/${client.id}/e`, { state: client });
  };
  console.log("client", client);
  return (
    <Main>
      <>
        <Helmet>
          <title>{`${client.challan_name}`}</title>
        </Helmet>
      </>
      <div>
        {client && (
          <Container>
            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                isdelete={isdelete}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="client"
              />
            )}

            <Col lg={2} className="mx-2">
              <Link to="/home" style={{ "text-decoration": "none" }}>
                Home
              </Link>{" "}
              {/* <i className="fa-solid fa-chevron-right"></i> */}
              <BsChevronRight />
              <Link to="/challans" style={{ "text-decoration": "none" }}>
                Client Invoice Payments
              </Link>
            </Col>
            <Row className="view-form">
              <Col></Col>
              <Col lg={8}>
                <Row className="view-form-header align-items-center">
                  <Col lg={4}>
                    {/* <div>client Id: {client.contactno}</div> */}
                    <h5>{client.party_name} (Invoice :{client.invoice_number}) </h5>
                  </Col>
                  <Col lg={8} className="d-flex justify-content-end">
                  <>
                  <Col style={{marginLeft: "180px"}} >
                    {/* <label>Year</label> */}
                    <p>{client.fname || ""}</p>
                  </Col>
                  </>
                    <Button
                      className="btn-sm mx-2"
                      onClick={() => editclient(true)}
                    >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                <Row>
                {/* <Col lg={6}>
                    <label>Challan Number</label>
                    <span>{client.challan_no || ""}</span>
                  </Col> */}
                  <Col lg={6}>
                    <label>Party Name</label>
                    <span>{client.party_name || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Total Invoice Amount</label>
                    <span>{client.total_invoice_amount || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>TDS</label>
                    <span>{client.tds || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Deduction</label>
                    <span>{client.deduction || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Outstanding</label>
                    <span>{client.outstanding || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Paid Amount</label>
                    <span>{client.paid_amount || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Payment Mode</label>
                    <span>{client.payment_mode || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Bank Name</label>
                    <span>{client.bank_name || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Cheque No</label>
                    <span>{client.cheque_no || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Remark</label>
                    <span>{client.remark || ""}</span>
                  </Col>
                  {/* <Col lg={6}>
                    <label>Vehicle ID</label>
                    <span>{client.vehicle_id || ""}</span>
                  </Col> */}
                  <Col lg={6}>
                    <label>Unloading Amount</label>
                    <span>{client.unloading_amount || ""}</span>
                  </Col>

                  {/* Section for User Information */}
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        User Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Created By</label>
                    <span>{client.createdbyname || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Created Date</label>
                    <span>
                      {new Date(client.createddate).toLocaleString() || ""}
                    </span>
                  </Col>
                  <Col lg={6}>
                    <label>Last Modified By</label>
                    <span>{client.lastmodifiedbyname || ""}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Last Modified Date</label>
                    <span>
                      {new Date(client.lastmodifieddate).toLocaleString() || ""}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col></Col>
            </Row>
          </Container>
        )}
      </div>
    </Main>
  );
};
export default ContactView;
